// src/context/OrderContext.jsx
import React, { createContext, useState, useContext } from 'react';

const OrderContext = createContext();

export const useOrder = () => useContext(OrderContext);

export const OrderProvider = ({ children }) => {
  const [selectedReference, setSelectedReference] = useState(null);

  const addReferenceImage = (portraitData) => {
    setSelectedReference({
      imageUrl: portraitData.imageUrl,
      title: portraitData.title,
      category: portraitData.category,
      description: portraitData.description,
      size: portraitData.size,
      tags: portraitData.tags || [],
      timestamp: new Date().toISOString()
    });
  };

  const clearReference = () => {
    setSelectedReference(null);
  };

  return (
    <OrderContext.Provider value={{
      selectedReference,
      addReferenceImage,
      clearReference
    }}>
      {children}
    </OrderContext.Provider>
  );
};